module.exports = __webpack_public_path__ + "static/img/10.7dcf824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/10.png
// module id = K9Oi
// module chunks = 0